<template>
    <div>
        <div v-if="discount !== null">
            <discount-form :discount="discount" @saved="reloadDiscount"></discount-form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {
                discount_id: parseInt(this.$route.params.id),
                discount: null,
            }
        },
        computed: Object.assign({}, mapGetters(['discounts', 'products'])),
        mounted() {
            this.reloadDiscount();
        },
        methods: {
            changeDiscount(newId, oldId) {
                this.discount_id = parseInt(newId)
                this.reloadDiscount()
            },
            reloadDiscount() {
                this.discount = null;
                setTimeout(() => {
                    this.discount = this.discounts.find(discount => discount.id === this.discount_id)
                })
            }
        },
        watch: {
            '$route.params.id': 'changeDiscount'
        }
    };
</script>



// WEBPACK FOOTER //
// DiscountEdit.vue?42aee35a